<template>
    <div class="system-message custom pb-20" v-if="message.data && message.data.text" v-html="this.getMessageText(message.data.text)">
    </div>
</template>

<script>
export default {
    props: {
        message: {
            type: Object,
            required: true
        },
    },

    methods: {
        /**
         * Очки
         */
        getPointsText(points) {
            return  this.$tc('message.point', points);
        },

        /** Дополнительное преобразование nl2br в тексте */
        getMessageText(text) {
            return (text + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, `$1<br>$2`);
        },
    }
}
</script>

<style scoped>

</style>
